const links = [].slice.call(document.querySelectorAll('link'));
const resourcePath = links.map(node => node.href).filter(href => href.indexOf('releasedAssets') > -1)[0];
const releasedAssetsPath = resourcePath && `${resourcePath.split('releasedAssets')[0]}releasedAssets/`;
__webpack_public_path__ = releasedAssetsPath;
